module.exports = __webpack_public_path__ + "img/3.b8b1e3ba.png";